import React, { useEffect, useCallback, useState} from 'react';
import {getMidiCCParametersForDevice, newMidiCCParameter} from 'decentralized/midi/midiCC.js';
import Dropdown from 'react-dropdown';
import {connect} from 'react-redux';
import EffectParameterSlider from './EffectParameterSlider.js';

const MidiCCEffectComponent = ({effect, sequencerEngine, effectNumber, lastMidiCCPlayed}) => { 
    let [device, setDevice] = useState(effect.deviceName);
    let [parameterOptions, setParameterOptions] = useState([]);
    let [name, setName] = useState("");
    let options = Object.keys(effect.midi.deviceToMidiCC).map(
        name => ({label: name, value: name}));

    useEffect(() => {
        if (!device) {
            setParameterOptions([]);
            return;
        }
        getMidiCCParametersForDevice(device.value || device)
            .then(n => setParameterOptions(
                n.map(({parameterName, ccNumber}) => ({
                    label: parameterName + ' (' + ccNumber + ')',
                    value: ccNumber
                }))));
    }, [device, setParameterOptions]);

    useEffect(() => {
        setDevice(effect.deviceName);
    }, [effect, setDevice]);

    const onChangeDevice = useCallback((name) => {
        effect.deviceNameParameter.set(name.value);
        setDevice(name);
    }, [setDevice]);

    const onClickMidiCC = useCallback(() => {
        if (lastMidiCCPlayed) {
            effect.midiCCNumberParameter.set(lastMidiCCPlayed.number);
            effect.midiCCValueParameter.set(lastMidiCCPlayed.value);
        }
    }, [lastMidiCCPlayed]);

    const saveParameterName = useCallback(() => {
        let ccNumber = effect.midiCCNumberParameter.get();
        newMidiCCParameter(effect.deviceName, ccNumber, name);
        setParameterOptions([
            ... parameterOptions,
            {label: name + ' (' + ccNumber + ')',
             value: ccNumber
            }]);
    }, [effect, name, parameterOptions, setParameterOptions]);

    const onSelectCC = useCallback((opt) => {
        effect.midiCCNumberParameter.set(opt.value);
    }, []);

    let parameterOption =  parameterOptions.find(
        opt => opt.value === effect.midiCCNumberParameter.get());

    return (
        <div className="midi-cc-effect">
          <Dropdown
            className='delay-time-dropdown'
            options={options}
            onChange={onChangeDevice}
            value={device}
            placeholder="Device" />
          {parameterOptions.length > 0 ? 
           <Dropdown
             className='delay-time-dropdown'
             options={parameterOptions}
             onChange={onSelectCC}
             value={parameterOption}
             placeholder="Choose Midi CC Param" /> : ''}
         <EffectParameterSlider
            effectNumber={effectNumber}
            name='CC Number'
            sequencerEngine={sequencerEngine}
            parameter={effect.midiCCNumberParameter}
            lfoEnabled={true}
            isParameter={true}
            onParameterChanged={() => []}
            step={1}
            max={119}
            min={0}
          />
          <EffectParameterSlider
            effectNumber={effectNumber}
            name='Value'
            sequencerEngine={sequencerEngine}
            parameter={effect.midiCCValueParameter}
            isParameter={true}
            onParameterChanged={() => []}
            lfoEnabled={true}
            step={1}
            max={128}
            min={0}
          />
          {parameterOption === undefined &&
           effect.midiCCNumberParameter.get() !== null &&
           effect.midiCCNumberParameter.get() !== undefined 
           ? 
          <div className="midi-cc-name-container">
            <input
              placeholder="Type parameter name"
              value={name} type="text" className="midi-cc-name" onChange={(e) => setName(e.target.value)}/>
            <div
              onClick={saveParameterName}
              className="label-button">
              Save
            </div>
          </div> : ''}
          
          {lastMidiCCPlayed ?
           <div
             onClick={onClickMidiCC}
             className="midi-cc-info">
             <div className="midi-cc-number">
               Midi CC: {lastMidiCCPlayed.number}
             </div>
             <div className="midi-cc-value">
               Value: {lastMidiCCPlayed.value}
             </div>
           </div> : ''}
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
      lastMidiCCPlayed: props.effect.id === state.effects.selectedEffect ?
          state.midi.lastMidiCCPlayed : undefined,
      ccNumber: props.effect.midiCCNumberParameter.get()
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MidiCCEffectComponent);
